import { render, staticRenderFns } from "./AxMealProcessingDialog.vue?vue&type=template&id=d920d7de&scoped=true"
import script from "./AxMealProcessingDialog.vue?vue&type=script&lang=ts"
export * from "./AxMealProcessingDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxMealProcessingDialog.vue?vue&type=style&index=0&id=d920d7de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d920d7de",
  null
  
)

export default component.exports